import React from 'react';
import { Col } from 'antd';
import OrganizationUnitSelect from 'works/components/organization-unit-select/organization-unit-select';
import { RoleSelect } from '@clinician-profile/components';
import { RoleType } from '@clinician-profile/graphql';

type UnitRoleSelectProps = {
  rolesData?: RoleType[];
  permittedDepartment: boolean;
};

export const UnitRoleSelect = ({
  rolesData,
  permittedDepartment,
}: UnitRoleSelectProps) => (
  <>
    <Col span={12}>
      <OrganizationUnitSelect
        scope={permittedDepartment ? 'department' : 'default'}
      />
    </Col>
    <Col span={12}>
      <RoleSelect roles={rolesData} />
    </Col>
  </>
);
